/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { render } from 'react-dom';
import IndexWrapper from '../container';

export default class Root extends Component {
    render() {
        return (
            <IndexWrapper />
        );
    }
}

render(
    <Root/>,
    document.getElementById('pages'),
);
